import { breakpoints } from '../config/breakpoints';

const onWcEvent = (events, callback) => {
  window.jQuery?.(document.body).on(events, callback);
};

const triggerWcEvent = (event, data = []) => {
  window.jQuery?.(document.body).trigger(event, data);
};

const applyFragments = (fragments) => {
  Object.keys(fragments).forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      const temp = document.createElement('div');
      temp.innerHTML = fragments[selector];
      if (temp.firstElementChild) el.replaceWith(temp.firstElementChild);
    });
  });
};

const refreshCartFragments = () => {
  if (!window.wc_cart_fragments_params?.wc_ajax_url) return;

  const url = window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'get_refreshed_fragments');

  fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: `time=${Date.now()}`,
  })
    .then((r) => r.json())
    .then((data) => {
      if (data?.fragments) {
        applyFragments(data.fragments);
        if (data.cart_hash) sessionStorage.setItem('wc_cart_hash', data.cart_hash);
        triggerWcEvent('wc_fragments_refreshed');
      }
    })
    .catch(() => {});
};

export default function () {
  const bottomBar = document.querySelector('.product-detail__control-block');
  const productBlock = document.querySelector('.product-detail');
  const detailsSection = document.querySelector('.shop__details');
  let windowWidth = window.innerWidth;

  let isMinimized = false;

  function handleScroll() {
    if (!bottomBar || !productBlock) return;

    if (windowWidth > breakpoints.lg) return;

    const windowHeight = window.innerHeight;

    const targetSection = detailsSection || document.querySelector('.footer');

    if (!targetSection) return;

    const targetRect = targetSection.getBoundingClientRect();
    const targetTop = targetRect.top;

    const shouldMinimize = targetTop <= windowHeight;

    if (shouldMinimize && !isMinimized) {
      isMinimized = true;
      bottomBar.classList.add('product-detail__control-block--hidden');
    } else if (!shouldMinimize && isMinimized) {
      isMinimized = false;
      bottomBar.classList.remove('product-detail__control-block--hidden');
    }
  }

  let scrollTimeout;
  function throttledScroll() {
    if (!scrollTimeout) {
      scrollTimeout = setTimeout(() => {
        handleScroll();
        scrollTimeout = null;
      }, 50);
    }
  }

  window.addEventListener('resize', () => {
    windowWidth = window.innerWidth;

    if (windowWidth > breakpoints.lg && bottomBar) {
      bottomBar.classList.remove('product-detail__control-block--hidden');
    }
  });

  window.addEventListener('scroll', throttledScroll);

  const initProductDetail = () => {
    const input = document.getElementById('product_quantity_0');
    const buttons = document.querySelectorAll('.c-quantity__button');
    const decreaseBtn = document.querySelector('.c-quantity__button--decrease');

    const updateDecreaseState = () => {
      if (!input) return;
      const currentValue = parseInt(input.value, 10);
      if (currentValue <= 1) {
        decreaseBtn.setAttribute('disabled', 'true');
      } else {
        decreaseBtn.removeAttribute('disabled');
      }
    };

    updateDecreaseState();

    buttons.forEach((button) => {
      button.addEventListener('click', updateDecreaseState);
    });

    let isUpdatingCart = false;
    const cartDrawer = document.querySelector('.cart-drawer');
    const cartCountElement = document.querySelector('.shop__sub-header-cart-count');
    const currentUrl = window.location.pathname;

    const findCartItemByUrl = () => {
      if (!cartDrawer) return null;
      const items = Array.from(cartDrawer.querySelectorAll('.cart-form__cart-item'));
      return items.find((item) => {
        const link = item.querySelector('.cart-form__name a');
        if (!link) return false;
        const href = link.getAttribute('href');
        return href && (href === currentUrl || href.endsWith(currentUrl));
      }) || null;
    };

    const updateCartCountFromDrawer = () => {
      if (isUpdatingCart || !cartDrawer || !cartCountElement) return;

      const cartItems = cartDrawer.querySelectorAll('.cart-form__cart-item');
      let totalQty = 0;
      cartItems.forEach((item) => {
        const qtyInput = item.querySelector('input.qty');
        if (qtyInput) {
          totalQty += parseInt(qtyInput.value, 10) || 0;
        }
      });

      cartCountElement.textContent = totalQty > 0 ? `(${totalQty})` : '';
    };

    onWcEvent('updated_cart_totals', () => {
      setTimeout(updateCartCountFromDrawer, 100);
    });

    const cartForm = document.querySelector('.product-detail__controls form.cart');
    if (cartForm) {
      const submitButton = cartForm.querySelector('button[type="submit"]');
      const originalText = submitButton?.textContent || 'Add to Cart';
      const activeText = submitButton.dataset?.activeTextI18n || 'Adding...';
      const { soldIndividually } = cartForm.dataset;
      const isSoldIndividually = soldIndividually === 'true';
      const controlsBlock = document.querySelector('.product-detail__controls');

      let productInCart = controlsBlock?.dataset.inCart === 'true';
      let isAddingToCart = false;

      const updateCartDrawerItem = (addedQty) => {
        const cartItem = findCartItemByUrl();
        if (cartItem) {
          const qtyInput = cartItem.querySelector('input.qty');
          if (qtyInput) {
            qtyInput.value = (parseInt(qtyInput.value, 10) || 0) + addedQty;
          }
        }

        const description = cartDrawer?.querySelector('.cart-form__description');
        if (description) {
          const match = description.textContent.match(/(\d+)/);
          if (match) {
            const newTotal = (parseInt(match[1], 10) || 0) + addedQty;
            description.textContent = `${newTotal} ${newTotal === 1 ? 'item' : 'items'} in your cart`;
          }
        }
      };

      cartForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        isAddingToCart = true;
        isUpdatingCart = true;

        const formData = new FormData(cartForm);
        const quantityInput = cartForm.querySelector('input[name="quantity"]');

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = activeText;
        }

        try {
          const response = await fetch(window.location.href, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          });

          // Wait for the full response to ensure WooCommerce has processed the cart update
          await response.text();

          if (response.ok) {
            if (isSoldIndividually) {
              productInCart = true;
              if (controlsBlock) {
                controlsBlock.style.display = 'none';
              }
            }

            const addedQty = parseInt(quantityInput?.value, 10) || 1;

            if (cartCountElement) {
              const curCount = parseInt(cartCountElement.textContent.replace(/[()]/g, ''), 10) || 0;
              cartCountElement.textContent = `(${curCount + addedQty})`;
            }

            updateCartDrawerItem(addedQty);

            // Small delay to ensure session is saved, especially for guests
            setTimeout(() => {
              refreshCartFragments();
            }, 300);

            if (quantityInput) {
              quantityInput.value = '1';
              updateDecreaseState();
            }
          } else {
            console.error('Failed to add product to cart');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalText;
          }
          setTimeout(() => {
            isAddingToCart = false;
            isUpdatingCart = false;
          }, 1500);
        }
      });

      if (isSoldIndividually) {
        const productId = controlsBlock?.dataset.productId;

        const showControls = () => {
          if (productInCart) {
            productInCart = false;
            if (controlsBlock?.style.display === 'none') {
              controlsBlock.style.display = '';
            }
          }
        };

        const checkProductInCart = () => {
          if (!productInCart || !cartDrawer) return;

          const foundByUrl = findCartItemByUrl();
          let foundById = false;

          if (productId) {
            const removeBtn = cartDrawer.querySelector(
              `.cart-form__remove[data-product-id="${productId}"]`,
            );
            foundById = !!removeBtn;
          }

          if (!foundByUrl && !foundById) {
            showControls();
          }
        };

        onWcEvent('removed_from_cart wc_cart_emptied', showControls);
        onWcEvent('updated_cart_totals', () => setTimeout(checkProductInCart, 500));

        if (cartDrawer) {
          const observer = new MutationObserver(() => {
            if (!isAddingToCart) setTimeout(checkProductInCart, 300);
          });
          observer.observe(cartDrawer, { childList: true, subtree: true });
        }
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductDetail);
  } else {
    initProductDetail();
  }
}
